<template>
  <section id="subPage" >
    <div class="container">
      <div class="row">
        <div class="col-md-12" v-if="!aramayiDuzelt">
          <div class="tabbable" style="margin: -40px 0px 15px 0px;">
                <div class="tab-content _pt-20">
                  <div class="tab-pane active" id="SearchBooking">
                    <div class="theme-search-area theme-search-area-stacked">
                      <form name="Searchbox" @submit.prevent="submit">
                        <div class="theme-search-area-form">
                          <div class="row">
                            <div class="col-md-5">
                              <div class="theme-search-area-section first theme-search-area-section-curved theme-search-area-section-bg-white theme-search-area-section-no-border theme-search-area-section-mr">
                                <div class="theme-search-area-section-inner" style="background-color: #ededed !important;">
                                    <i class="theme-search-area-section-icon fas fa-map-marker-alt"></i>
                                    <md-autocomplete v-model="selectedAlisYeri" :md-options="alisYeri" md-layout="box" md-dense class="theme-search-area-section-input">
                                      <label>Nereden Alacaksınız?</label>
                                    </md-autocomplete>
                                </div>
                              </div>
                              <div v-if="farkliLokasyon==true" class="farkliIade-input theme-search-area-section first theme-search-area-section-curved theme-search-area-section-bg-white theme-search-area-section-no-border theme-search-area-section-mr">
                                <div class="theme-search-area-section-inner" style="background-color: #ededed !important;">
                                    <i class="theme-search-area-section-icon fas fa-map-marker-alt"></i>
                                    <md-autocomplete v-model="selectedIadeYeri" :md-options="alisYeri"  md-layout="box"  md-dense class="theme-search-area-section-input">
                                      <label>Nereye Bırakacaksınız?</label>
                                    </md-autocomplete>
                                </div>
                              </div>
                              <div v-if="PromosyonKodumVar==true" class="farkliIade-input theme-search-area-section first theme-search-area-section-curved theme-search-area-section-bg-white theme-search-area-section-no-border theme-search-area-section-mr">
                                <div class="theme-search-area-section-inner" style="background-color: #ededed !important;">
                                    <i class="theme-search-area-section-icon fas fa-hashtag"></i>
                                    <md-field md-layout="box" md-dense class="theme-search-area-section-input">
                                      <label class="promosyon">Promosyon Kodu</label>
                                      <md-input v-model="PromotionCode"  />
                                    </md-field>
                                </div>
                              </div>
                              <div class="theme-search-area-options _mob-h theme-search-area-options-white theme-search-area-options-dot-primary-inverse clearfix">
                                <div class="btn-group theme-search-area farkliIade">
                                    <md-checkbox type="checkbox" class="farkliIade_checkbox whiteBorder" style="color: gray !important;border-color: rgba(0,0,0,0.54) !important;" v-model="farkliLokasyon" @change="FarkliLokasyonBosalt">Farklı Yere İade</md-checkbox>
                                    <md-checkbox type="checkbox" class="farkliIade_checkbox whiteBorder" style="color: gray !important;border-color: rgba(0,0,0,0.54) !important;" v-model="PromosyonKodumVar" @change="PromosyonBosalt">Promosyon Kodu</md-checkbox>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-bg-white theme-search-area-section-no-border theme-search-area-section-mr">
                                    <div class="theme-search-area-section-inner md-elevation-2" style="background-color: #ededed !important;">
                                      <i class="theme-search-area-section-icon fas fa-calendar-alt"></i>
                                        <datetime type="datetime" v-model="datetimeAlisTarihi" class="vdatetime-input theme-red col-md-5 theme-search-area-section-input datePickerStart _mob-h"
                                                  :format="{ year: 'numeric', day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' }"
                                                  :phrases="{ok: 'Devam', cancel: 'Kapat'}"
                                                  :minute-step="15"
                                                  auto ref="datepickerAlis"
                                                  input-id="datetimeAlisTarihi"
                                                  :week-start="1" placeholder="Alış Tarihi"
                                                  :min-datetime="new Date().toISOString()">
                                        </datetime>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-6">
                                  <div class="theme-search-area-section theme-search-area-section-curved theme-search-area-section-bg-white theme-search-area-section-no-border theme-search-area-section-mr">
                                    <div class="theme-search-area-section-inner md-elevation-2" style="background-color: #ededed !important;">
                                      <i class="theme-search-area-section-icon fas fa-calendar-alt"></i>
                                        <datetime type="datetime" v-model="datetimeIadeTarihi" class="vdatetime-input theme-red col-md-5 theme-search-area-section-input datePickerEnd _mob-h"
                                                    :format="{ year: 'numeric', day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' }"
                                                    :phrases="{ok: 'Devam', cancel: 'Kapat'}"
                                                    :minute-step="15"
                                                    auto ref="datepickerIade"
                                                    input-id="datetimeIadeTarihi"
                                                    :week-start="1" placeholder="İade Tarihi"
                                                    :min-datetime="datetimeAlisTarihi && new Date(datetimeAlisTarihi).toISOString()">
                                        </datetime>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <button type="submit" class="theme-search-area-submit _mt-0 theme-search-area-submit-no-border theme-search-area-submit-curved  md-elevation-1">ARA</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="leftBlock">
                <h4>Araç Alış Bilgileri</h4>
                <p>{{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.alisTarihi}} - {{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.alisSaati}}<br>{{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.alisYeri}}</p>
                <h4>Araç İade Bilgileri</h4>
                <p>{{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.iadeTarihi}} - {{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.iadeSaati}}<br>{{this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.iadeYeri}}</p>

                <h4>Toplam {{this.$store.state.GetServerData.BookingDates.gunToplam}} gün</h4>


          <button class="btn btn-danger btn-xs" style="width: 100%;" v-on:click="aramayiDuzelt = !aramayiDuzelt">Seçimleri Değiştir</button>
          </div><br>
          <button class="btn btn-danger btn-xs" style="width: 100%; margin-bottom:20px;" v-if="isMobileButton==true" v-on:click="isMobile = !isMobile">Filtrele</button>
            <div class="carFilter" v-if="isMobile">
              <form>
                <div class="form-group">
                  <label for="carGear">VİTES</label>
                  <select class="form-control" id="carGear" v-model="transmission">
                    <option value="all">Seçim Yapılmadı</option>
                    <option value="Otomatik">Otomatik</option>
                    <option value="Manuel">Manuel</option>
                    <option value="Yarı Otomatik">Yarı Otomatik</option>
                  </select>
              <!--<label for="carGear">Vites</label>
                  <md-select v-model="transmission" name="transmission" id="transmission">
                    <md-option value="all">Seçim Yapılmadı</md-option>
                    <md-option value="Otomatik">Otomatik</md-option>
                    <md-option value="Manuel">Manuel</md-option>
                    <md-option value="Yarı Otomatik">Yarı Otomatik</md-option>
                  </md-select>-->
                </div>
                <div class="form-group">
                  <label for="carFuel">YAKIT TİPİ</label>
                  <select class="form-control" id="carFuel" v-model="fueltype">
                    <option value="all">Seçim Yapılmadı</option>
                    <option value="Dizel">Dizel</option>
                    <option value="Benzin">Benzin</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>SINIF</label>
                  <select class="form-control" id="carClass" v-model="segment">
                    <option value="all">Seçim Yapılmadı</option>
                    <option value="B">B Segment</option>
                    <option value="B+">B+ Segment</option>
                    <option value="C">C Segment</option>
                    <option value="C+">C+ Segment</option>
                    <option value="D">D Segment</option>
                    <option value="D+">D+ Segment</option>
                    <option value="E">E Segment</option>
                    <option value="E+">E+ Segment</option>
                    <option value="Luxury">Luxury</option>
                    <option value="SUV">SUV</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="carPessenger">YOLCU KAPASİTESİ</label>
                  <select class="form-control" id="carPessenger" v-model="passengercapacity">
                    <option value="all">Seçim Yapılmadı</option>
                    <option value="4">4 Kişilik</option>
                    <option value="5">5 Kişilik</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="carLuggage">BAGAJ KAPASİTESİ</label>
                  <select class="form-control" id="carLuggage" v-model="baggagecapacity">
                    <option value="all">Seçim Yapılmadı</option>
                    <option value="3">3 Valiz</option>
                    <option value="4">4 Valiz</option>
                    <option value="5">5 Valiz</option>
                  </select>
                </div>
                <!-- <div class="form-group">
                  <label for="carLuggage">Fiyat Aralığı (Günlük)</label>
                  <input type="text" class="js-range-slider" name="my_range" value="" />
                  <input type="hidden" id="carPriceFrom"><input type="hidden" id="carPriceTo">
                  <div class="minmax">
                    <div id="carPriceFromLabel"></div>
                    <div id="carPriceToLabel"></div>
                  </div>
                </div> -->
              </form>
            </div>
        </div>
        <div class="col-md-8 cont">
          <nav class="navbar navbar-expand-lg navbar-light">
            <a class="navbar-brand" href="#" style="text-decoration: none;pointer-events: none;">ARAÇLAR</a>
            <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav">
                <li class="nav-item active"><router-link to="/" class="nav-link">Ana Sayfa <span class="sr-only">(current)</span></router-link></li>
                <!-- <li class="nav-item"><a class="nav-link" href="#">Örnek</a></li> -->
                <li class="nav-item"><a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Araçlar</a></li>
              </ul>
            </div>
          </nav>
          <div  v-for="result in filteredCars" v-bind:data="result" v-bind:key="result.Id">
          <md-toolbar class="md-transparent car">
            <div class="md-toolbar-row">
              <h3 class="md-title">{{result.SubGroupName}} <small>veya benzeri</small></h3>
              <div class="md-toolbar-section-end" v-if="result.DiscountedDays">
                <div>
                  <span style="color:#f54336;">
                    <strong>{{result.DiscountedDays}} GÜN DAHA AZ ÖDE</strong>
                  </span>
                </div>
              </div>

              <div class="md-toolbar-section-end"  style="width: 100%;">
                <div style="width: 126px;" v-if="result.CampaignId && result.IsBolBol!=1">
                  <img src="../../static/assets/img/kampanya.png" style="height:20px;width:20px;">
                  <span style="color:#f54336;">
                    <strong>KAMPANYA</strong>
                  </span>
                </div>
                <div v-if="result.IsBolBol=='1' && result.CampaignId!='1498'" style="width: 170px;">
                  <img src="../../static/assets/img/pegasusbolbol.jpg"><br>
                   <!-- <p style="text-align: center;margin-top:5px;"><strong>700 BolPuan Kazanın</strong></p> -->
                </div>
                <div v-if="result.CampaignId=='1498'" style="width: 170px;">
                  <img src="../../static/assets/img/pegasusbolbol1500.jpg"><br>
                   <!-- <p style="text-align: center;margin-top:5px;"><strong>700 BolPuan Kazanın</strong></p> -->
                </div>

              </div>

            </div>
            <div class="md-layout md-gutter md-alignment-center md-layout-iefix">
            <div class="md-layout-item pic md-small-size-100 md-xsmall-size-100 ">
              <img v-bind:src="`${result.imageUrl}`" v-bind:alt="`Kiralık ${result.SubGroupName} ${result.FuelType} ${result.Transmission}`" style="">
            </div>
            <div class="md-layout-item md-small-size-100 md-xsmall-size-100">
              <ul>
                <li class="fuelType">{{result.FuelType}}</li>
                <li class="gear">{{result.Transmission}} Vites</li>
                <li class="age">+{{result.DriverMinAge}} Yaş</li>
                <li class="license">+{{result.DriverMinLicenceYear}} Yıllık Sürücü</li>
                <li class="luggage">{{result.BaggageCapacity}} B</li>
                <li class="pessenger">{{result.PassengerCapacity}} Kişi</li>
              </ul>
<!--                result.WebPaymentNonDiscountedPrice-->
              <span class="newPrice float-left" style="margin-right:25px;">{{result.DiscountedDailyPriceOnly}} TL<i>Günlük Tutar</i></span>

              <!-- <span class="oldPrice float-left">{{result.WebPaymentNonDiscountedPrice}} <i>TL Ofiste Öde Fiyatı</i></span> -->
              <span class="newPrice float-left">
<!--                  <strong v-if="result.WebPaymentPrice>result.DiscountedDailyPrice" style="text-decoration: line-through;font-weight: 600;font-size: 15px;color: gray;">{{result.WebPaymentPrice}} TL</strong>
                  <br v-if="result.WebPaymentPrice>result.DiscountedDailyPrice">-->
                  <span>{{result.DiscountedDailyPrice}} TL</span>  <i>Toplam Tutar</i>
              </span>

              <router-link class="btnRed float-right"
              v-on:click.native="tagManagerVehicleClick(result.MakeName,result.ModelName,result.SubGroupId,result.DiscountedDailyPrice,result.FuelType,result.Transmission,result.DriverMinLicenceYear,result.DriverMinAge,result.PassengerCapacity,result.BaggageCapacity,result.Segment,result.sira)"
              :to="'/ekstralar/' + result.SubGroupId+'/'+result.SubGroupShortName">
              ŞİMDİ ÖDE <i class="fas fa-long-arrow-alt-right"></i>
              </router-link>
            </div>
              <div style="width: 100%;text-align: right;margin-right:20px;margin-top:20px;" v-if="result.DropStatu=='1'">
                <span style="font-size:11px;font-weight: 300;">*{{result.DropPrice}} TL farklı lokasyona iade ücreti dahildir.</span>
              </div>
              <div style="width: 100%;text-align: right;margin-right:20px;margin-top:20px;" v-if="Age && Age<result.DriverMinAge">
                <span style="font-size:11px;font-weight: 300;">*Bu aracı kiralayabilmek için <strong>Genç Sürücü</strong> ek paketi satın almalısınız.</span>
              </div>
            </div>
          </md-toolbar>
          </div>

          <div v-if="!filteredCars.length" style="text-align:center;">
            <img style="width:50%" src="../../static/assets/img/car-not-found.png"><br>
            <h3>Araç Bulunamadı..</h3><br>
            <h6>Aradığınız kriterlere uygun araç bulunamadı lütfen farklı seçimlerle ilerleyiniz.</h6>
          </div>


        </div>
      </div>
      <md-dialog-alert
      :md-active.sync="hataMesajiDurum"
      :md-title="`${hataMesajiBaslik}`"
      :md-content="`${hataMesaji}`" />
    </div>
  </section>
</template>

<script>
import { Datetime } from 'vue-datetime';
import axios from 'axios'
import store from '../store'
export default {
  name: "vehicle",
  metaInfo: () => ({
    title: 'Kiralık Araçlar',
    titleTemplate: '%s - PopyCar',
    htmlAttrs: {
      lang: 'tr',
      amp: true
    },
    meta: [
      { name: 'description', content: 'Kiralık Araçlar' }
    ]
  }),
  components: {
    datetime: Datetime
  },
  data () {
    return {
      sonuc: [],
      farkliLokasyon: this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.alisYeri !=  this.$store.state.GetServerData.BookingDates.iadeYeri ? true : false,
      PromosyonKodumVar: this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.promosyon !=  '' && this.$store.state.GetServerData.BookingDates.promosyon !=  null ? true : false,
      datetime: Datetime,
      datetimeAlisTarihi: '',
      datetimeIadeTarihi: '',
      selectedAlisYeri: '',
      selectedIadeYeri: '',
      PromotionCode: this.$store.state.GetServerData.BookingDates && this.$store.state.GetServerData.BookingDates.promosyon !=  '' && this.$store.state.GetServerData.BookingDates.promosyon !=  'undefined' ? this.$store.state.GetServerData.BookingDates.promosyon : '',
      alisYeri: [],
      isLoading: false,
      fullPage: true,
      loader: 'bars',
      color: '#d2202f',
      transmission: 'all',
      fueltype: 'all',
      passengercapacity: 'all',
      segment: 'all',
      baggagecapacity: 'all',
      Age: '',
      tagDatalari:[],
      aramayiDuzelt: true,
      isMobile: true,
      isMobileButton: false,
      hataMesajiDurum: false,
      hataMesaji: false,
      hataMesajiBaslik: false
    }
  },
  created (){

    var locationList = []
    axios.get(process.env.VUE_APP_API_URL+'serviceSearchingStations.php?query=1', {withCredentials: true, headers: {
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Access-Control-Allow-Origin': '*'
    }}).then(sonuc => {
       this.$forceUpdate()
      for (var i = 0; i < sonuc.data.length; i++) {
        locationList[i] = sonuc.data[i].Name
      }
      this.alisYeri = locationList
    })
  },
  mounted () {
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
      this.isMobile = false;
      this.isMobileButton = true
    }
    this.Age = this.$store.state.GetServerData.member && this.$store.state.GetServerData.member.Age
    let loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      loader: this.loader,
      color: this.color,
      opacity: 0.90,
      /* height: '120px',
      width: '120px',*/
    });
    axios.get(process.env.VUE_APP_API_URL+'aracSecimi.php?alisYeri='+this.$route.params.alisYeri+'&iadeYeri='+this.$route.params.iadeYeri+'&alisTarihi='+this.$route.params.alisTarihi+'&iadeTarihi='+this.$route.params.iadeTarihi,{withCredentials: true, headers: {
    'Cache-Control': 'no-cache','Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Access-Control-Allow-Origin': '*'
    }}).then(response => {
      this.sonuc = response.data;


      loader.hide()
      response.data.forEach((datalar) => {
        this.tagDatalari.push({
                  id: datalar.SubGroupId,
                  name: datalar.ModelName,
                  price: datalar.DiscountedDailyPrice,
                  category: datalar.MakeName,
                  position: datalar.sira,
                  list: "Anasayfa / Araçlar / " + datalar.MakeName,
                  variant: datalar.ModelName,
                  brand: datalar.MakeName,
                  dimension1: datalar.FuelType,
                  dimension2: datalar.transmission,
                  dimension3: datalar.DriverMinLicenceYear,
                  dimension4: datalar.DriverMinAge,
                  dimension5: datalar.PassengerCapacity,
                  dimension6: datalar.BaggageCapacity,
                  dimension7: datalar.Segment
        });
      });
    });
    // this.$gtm.trackEvent({
    //     event: 'EEprodImpression',
    //     ecommerce: {
    //       currencyCode: "TRY",
    //        impressions: [this.tagDatalari]
    //     }
    // });
  },
  computed: {
    filteredCars: function() {
      var Transmission = this.transmission;
      var FuelType = this.fueltype;
      var PassengerCapacity = this.passengercapacity;
      var Segment = this.segment;
      var BaggageCapacity = this.baggagecapacity;
      if(Transmission === 'all' && FuelType === 'all' && PassengerCapacity === 'all' && Segment === 'all' && BaggageCapacity === 'all') {
        return this.sonuc;
      } else {
        return this.sonuc.filter(function(result) {
          return (Transmission === 'all' || result.Transmission === Transmission) && (FuelType === 'all'  || result.FuelType === FuelType) && (PassengerCapacity === 'all'  || result.PassengerCapacity === PassengerCapacity) && (Segment === 'all'  || result.Segment === Segment) && (BaggageCapacity === 'all'  || result.BaggageCapacity === BaggageCapacity);
        });
      }
    }
  },
  methods:{
    submit: function () {
      let loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      loader: this.loader,
      color: this.color,
      opacity: 0.90,
      /*height: '120px',
      width: '120px',*/
      });
      let PromosyonKoduSecimi;
      let farkliLokasyonSecimi;
      this.selectedAlisYeri && this.selectedIadeYeri==null ? this.selectedIadeYeri=this.selectedAlisYeri : ''
      this.PromosyonKodumVar && this.PromosyonKodumVar==true ? PromosyonKoduSecimi='1' : PromosyonKoduSecimi='0'
      this.farkliLokasyon && this.farkliLokasyon==true ? farkliLokasyonSecimi='1' : farkliLokasyonSecimi='0'

      axios.get(process.env.VUE_APP_API_URL+'serviceHoursDay.php?PickUpStation=' + this.selectedAlisYeri + '&DropOffStation=' + this.selectedIadeYeri + '&pickupdate=' + this.datetimeAlisTarihi + '&dropoffdate=' + this.datetimeIadeTarihi + '&Promo=' + this.PromotionCode+ '&KampanyaId=&PromosyonKodumVar='+PromosyonKoduSecimi+'&farkliLokasyon='+farkliLokasyonSecimi, {withCredentials: true, headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }}).then(res => {
        if (res.data.status=='success') {
          store.commit('UpdateServerData', {
            BookingDates : res.data
           });
          window.location.href = '/kiralik-araclar/' + res.data.alisCode + '/' + res.data.iadeCode + '/' + this.datetimeAlisTarihi + '/' + this.datetimeIadeTarihi;
          //location.reload();
          //this.$router.push('/kiralik-araclar/' + res.data.alisCode + '/' + res.data.iadeCode + '/' + this.datetimeAlisTarihi + '/' + this.datetimeIadeTarihi)
          loader.hide()
          //this.$store.state.StoreLokasyon.AlisYeri=this.selectedAlisYeri;
        }
        if (res.data.status=='error'){
          this.hataMesajiDurum = true
          this.hataMesajiBaslik=res.data.baslik
          this.hataMesaji=res.data.mesaj
          loader.hide()
        }
      })
    },
    openIade() {
      if(this.$refs.datepickerIade){
        this.$refs.datepickerIade.open(event);
      }
    },
    openAlis() {
      if(this.$refs.datepickerAlis){
    	  this.$refs.datepickerAlis.open(event);
      }
    },
    FarkliLokasyonBosalt:function() {
      if (this.farkliLokasyon==false){
        this.selectedIadeYeri=''
      }
    },
    PromosyonBosalt:function() {
      if (this.PromosyonKodumVar==false){
        this.PromotionCode=''
      }
    },
    tagManagerVehicleClick(MakeName,ModelName,SubGroupId,DiscountedDailyPrice,FuelType,Transmission,DriverMinLicenceYear,DriverMinAge,PassengerCapacity,BaggageCapacity,Segment,sira){
    //   this.$gtm.trackEvent({
    //     event: 'EEProductClick',
    //     ecommerce: {
    //       click: {
    //         actionField: {'list': 'PopyCar Car / Araçlar /'+MakeName},
    //         products: [{
    //             id: SubGroupId,
    //             name: ModelName,
    //             price: DiscountedDailyPrice,
    //             category: MakeName,
    //             position: sira,
    //             list: "PopyCar Car / Araçlar / "+MakeName,
    //             variant: ModelName,
    //             brand: MakeName,
    //             dimension1: FuelType,
    //             dimension2: Transmission,
    //             dimension3: DriverMinLicenceYear,
    //             dimension4: DriverMinAge,
    //             dimension5: PassengerCapacity,
    //             dimension6: BaggageCapacity,
    //             dimension7: Segment
    //           }]
    //       }
    //     }
    // })
    },
    /* isMobile: function() {
    	var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }*/
  }
}
</script>
<style>
#subPage input:focus, #subPage select:focus, #subPage textarea:focus{
  border: none !important;
}
#subPage input {
    height: 40px;
    font-size: 14px;
    border: none !important;
    color: #4a4a4a;
    /* background-color: transparent !important;*/
}
</style>
